import { IModel, IncludedType, ITypedModel } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Model } from 'utility-ts-orm';

export interface IAPProgram {
  area_of_study: string;
  cat_yr: number;
  cd: string;
  credential: string;
  credential_id: number;
  credits: string;
  desc: string;
  estimated_tuition: string;
  favorite_id: number;
  hiring_demand: string;
  id: number;
  is_favorite: boolean;
  min_dev_course: number;
  name: string;
  nk: string;
  rank: string;
  salary_trend_max: string;
  salary_trend_min: string;
  short_credential: string;
  plan_instructions: string;
  short_plan_instructions: string;
  student_program_activity: string[];
  student_program_subject: string[];
}
export interface IAPModel {
  planned_term: number[];
  program: Record<string, IAPProgram>;
}

export class APModel implements IModel {
  private data: IAPModel;
  constructor() {
    this.data = { planned_term: [], program: {} };
  }
  update(data: Partial<IAPModel>) {
    this.clear();
    return this.write(data);
  }
  write(data: Partial<IAPModel>) {
    this.data = _4.merge(this.data, data);
    return this;
  }
  read(): IAPModel {
    return this.data;
  }
  clear() {
    this.data = { planned_term: [], program: {} };
    return this;
  }
  addPlannedTerm(termId: number) {
    this.data.planned_term.push(termId);
    this.data.planned_term = _4.uniq(this.data.planned_term);
  }
  currentProgram() {
    return _4.head(_4.toArray(this.data.program));
  }
  removePlannedTerm(termId: number) {
    this.data.planned_term = _4.uniq(_4.pull(this.data.planned_term, termId));
  }
}

angular.module('capability-ng-academic-planner').service('ngAPModel', APModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/models/ap_model.ts